import { Link, useParams } from 'react-router-dom';

import { BlogLayout } from './BlogLayout';
import { BlogProse } from './BlogProse';
import { EvalSpreadChart } from './components/EvalSpreadChart';
import { formatPostDate, getPostBySlug } from './posts';

const CHART_SLOT_RE = /\n?\[\[chart:eval-spread\]\]\n?/;

export const BlogPostRoute = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : undefined;

  if (!post) {
    return (
      <BlogLayout>
        <section className="px-6 py-20 text-center">
          <p className="text-lg text-text-secondary">Post not found.</p>
          <Link to="/blog" className="mt-6 inline-block text-sm font-medium text-primary">
            ← Back to all posts
          </Link>
        </section>
      </BlogLayout>
    );
  }

  const { frontmatter, body } = post;
  const [intro, rest] =
    frontmatter.chart === 'eval-spread'
      ? body.split(CHART_SLOT_RE, 2)
      : [body, undefined];

  return (
    <BlogLayout>
      <article className="px-6 py-12 md:py-16">
        <div className="mx-auto max-w-3xl">
          <Link to="/blog" className="text-sm font-medium text-primary">
            ← All posts
          </Link>

          <header className="mt-6 border-b border-border pb-8">
            {frontmatter.date ? (
              <p className="text-xs uppercase tracking-wide text-text-tertiary">
                {formatPostDate(frontmatter.date)}
              </p>
            ) : null}
            <h1 className="mt-2 font-serif text-3xl font-semibold leading-tight text-text-primary md:text-4xl">
              {frontmatter.title}
            </h1>
            {frontmatter.summary ? (
              <p className="mt-4 text-lg text-text-secondary">{frontmatter.summary}</p>
            ) : null}
          </header>

          <div className="mt-6">
            <BlogProse source={intro} />
            {rest !== undefined ? (
              <>
                <EvalSpreadChart />
                <BlogProse source={rest} />
              </>
            ) : null}
          </div>

          <div className="mt-12 border-t border-border pt-6 text-sm">
            <Link to="/blog" className="font-medium text-primary">
              ← All posts
            </Link>
          </div>
        </div>
      </article>
    </BlogLayout>
  );
};
